import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
var axios = require("axios");
var platform = require('platform');
let localversion = `1.0.22`;

export default class Announcement extends Component {
  constructor(){
    super()
    this.state = {latest:true};
  }
  async componentDidMount(){
    let headers = { 'Content-Type': 'application/json'}
    // let url = `http://localhost:3002/version`;
    let url = `https://borderless-version.herokuapp.com/version`;
    let _this = this;
    let response = await fetch(url, {method: 'get', headers})
    let json = await response.json()
    if(json && json.version && json.version !== localversion) _this.setState({latest:false})
    setInterval(async ()=>{
      let response = await fetch(url, {method: 'get', headers})
      let json = await response.json()
      if(json && json.version && json.version !== localversion) _this.setState({latest:false})
    },1000*60*10)
  }
  render() {
    let url = `https://overline.network/Interchange.dmg`;
    if(platform.os.toString().includes(`Windows`)) url = `https://overline.network/Interchange.exe`;
    if(platform.os.toString().includes(`Linux`)) url = `https://overline.network/Interchange.AppImage`;

    return (
      <>
      {!this.state.latest &&
        <div className="announcement2 minWidth">
          <a href={url}>
            <span style={{ paddingLeft: 15, paddingRight: 15 }}>
              CLICK HERE TO UPDATE Interchange
            </span>
          </a>
        </div>
      }
      <div className="announcement minWidth">
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          style={{ color: "#000",fontSize:'0.75rem' }}
        />
        <span style={{ paddingLeft: 15, paddingRight: 15 }}>
          WARNING: Overline Wallet IS IN A SOFT OPENING PERIOD. PLEASE USE WITH CAUTION.
        </span>
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          style={{ color: "#000",fontSize:'0.75rem' }}
        />
      </div>
      </>
    );
  }
}
